import color from './colorThemes'
import config from '../../../config'

const { minZoom } = config.map
const delay = 2.5
const start = minZoom + delay
const end = start + 1

export default {
  source: 'osm',
  'source-layer': 'buildings',
  type: 'fill',
  id: 'buildings',
  minzoom: start,
  paint: {
    'fill-color': color.buildings,
    'fill-opacity': {
      base: 1.5,
      stops: [[start, 0], [end, 1]],
    },
  },
}
